define.alias("shared/utils/number-helpers/compute-sign", "calendar/utils/number-helpers/compute-sign");